var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifyIdentityDrivingLicense(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2855_93501)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2005 19.3333C36.9336 18.5332 36.2005 18 35.3333 18H20.6667C19.7995 18 19.0664 18.5332 18.7995 19.3333L16.0658 26.4944C16.0223 26.6083 16 26.7292 16 26.8511V36.6667C16 37.3997 16.6003 38 17.3333 38H18.6667C19.3997 38 20 37.3997 20 36.6667V36H36V36.6667C36 37.3997 36.6003 38 37.3333 38H38.6667C39.3997 38 40 37.3997 40 36.6667V26.8511C40 26.7292 39.9777 26.6083 39.9342 26.4944L37.2005 19.3333Z",
    fill: "white",
    stroke: "#BFBFBF",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1083 25.35H19.8917L21.4024 20.65H34.5976L36.1083 25.35ZM34.5864 20.6153L34.5865 20.6154C34.5865 20.6154 34.5865 20.6153 34.5864 20.6153L34.634 20.6L34.5864 20.6153Z",
    fill: "#F0F0F0",
    stroke: "#BFBFBF",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3336 32C34.2008 32 33.3336 31.1334 33.3336 30C33.3336 28.8666 34.2008 28 35.3336 28C36.4664 28 37.3336 28.8666 37.3336 30C37.3336 31.1334 36.4664 32 35.3336 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.667 32C19.5342 32 18.667 31.1334 18.667 30C18.667 28.8666 19.5342 28 20.667 28C21.7998 28 22.667 28.8666 22.667 30C22.667 31.1334 21.7998 32 20.667 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3336 32C34.2008 32 33.3336 31.1334 33.3336 30C33.3336 28.8666 34.2008 28 35.3336 28C36.4664 28 37.3336 28.8666 37.3336 30C37.3336 31.1334 36.4664 32 35.3336 32Z",
    stroke: "#BFBFBF",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.667 32C19.5342 32 18.667 31.1334 18.667 30C18.667 28.8666 19.5342 28 20.667 28C21.7998 28 22.667 28.8666 22.667 30C22.667 31.1334 21.7998 32 20.667 32Z",
    stroke: "#BFBFBF",
    strokeWidth: 1.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2855_93501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyIdentityDrivingLicense);
export default __webpack_public_path__ + "static/media/verify-identity-driving-license.7edbaf9f40ae12d4bdcb0415b9c821e9.svg";
export { ForwardRef as ReactComponent };